import React from 'react';
import {MuiThemeProvider} from 'material-ui/styles';
import {withRouter} from 'react-router-dom';
import { AuthenticationService } from '../../Services/AuthenticationService';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import ListSubheader from '@material-ui/core/ListSubheader';

let globalProps;
class WorkshopTemplate extends React.Component {

    constructor(props) {
        super(props);
        globalProps = props;
        
        const authService = AuthenticationService.getInstance();
        if (!authService.isLoggedIn()) {
            globalProps.history.push('/login/redirect');
        } else if (!authService.isAdministrator()) {
            authService.denyNonAdministratorAccess();
        } else {
            this.loadUser();
        }
    }

    loadUser() {
        const authService = AuthenticationService.getInstance();
        const user = authService.getUser();
        
        this.state = {
            user: user,
            loading: false,
            jwtToken: authService.getToken(),
            open: false,
            anchorEl: null
        };
    }

    handleProfileMenuOpen = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleProfileMenuClose = () => {
        this.setState({ anchorEl: null });
    };

    handleMyProfile = () => {
        this.handleProfileMenuClose();
        // Route to mobile profile if screen width is 960px or less
        if (window.innerWidth <= 960) {
            globalProps.history.push('/profile');
        } else {
            globalProps.history.push('/admin/profile');
        }
    };

    handleLogout = () => {
        this.handleProfileMenuClose();
        this.logout();
    };

    getInitials = (name) => {
        if (!name) return 'U';
        const names = name.split(' ');
        if (names.length === 1) {
            return names[0].charAt(0).toUpperCase();
        }
        return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
    };

    logout = () => {
        const authService = AuthenticationService.getInstance();
        authService.logout();
    };

    render() {
        const authService = AuthenticationService.getInstance();
        if (!authService.isLoggedIn()) {
            window.location.reload();
            return '';
        }
        if (!authService.isAdministrator()) {
            authService.denyNonAdministratorAccess();
            return '';
        }

        return (
            <MuiThemeProvider>
                <div className="mobile-root">
                    <div style={{ position: 'relative' }}>
                        <img src={require("../../JXB Logo.jpg")} alt="JXB Performance" style={{width: '100%', maxWidth: '300px', cursor: 'pointer'}} onClick={() => globalProps.history.push('/admin/parts')} />
                        <IconButton
                            onClick={this.handleProfileMenuOpen}
                            style={{
                                position: 'absolute',
                                top: '0',
                                right: '10px',
                                backgroundColor: '#1976d2',
                                color: '#ffffff',
                                width: '40px',
                                height: '40px',
                                zIndex: 1000
                            }}
                        >
                            <Avatar
                                style={{
                                    backgroundColor: 'rgb(0 242 255)',
                                    color: '#000',
                                    fontSize: 21,
                                    fontWeight: 'bold',
                                    borderRadius: '300px !important'
                                }}
                            >
                                {this.getInitials(this.state.user?.firstName + ' ' + this.state.user?.lastName || this.state.user?.email)}
                            </Avatar>
                        </IconButton>
                        <Menu
                            anchorEl={this.state.anchorEl}
                            open={Boolean(this.state.anchorEl)}
                            onClose={this.handleProfileMenuClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                        >
                            <ListSubheader style={{lineHeight: '20px', height: '20px'}}>{this.state.user?.firstName + ' ' + this.state.user?.lastName}</ListSubheader>
                            <MenuItem onClick={this.handleMyProfile}>My Profile</MenuItem>
                            <Divider />
                            <MenuItem onClick={this.handleLogout}>Logout</MenuItem>
                        </Menu>
                    </div>
                    {this.props.children}
                    <div style={{width: '100%', display: 'inline-block', marginTop: 20}}>
                        <center>&#9400; {new Date().getFullYear()} JXB Performance, All rights reserved.</center>
                    </div>
                </div>
            </MuiThemeProvider>
        );
    }
}

WorkshopTemplate = withRouter(WorkshopTemplate);
export default WorkshopTemplate;
